import { createDivIn, createExternalImgIn, createParagraphIn } from '../ui_utils/DomUtils.ts';
import { createDeferredPromise } from '@colonist/utils';
import IconLogo from '@static/images/logo.svg';
import IconArrowWhite from '@static/images/icon_arrow_white.svg';
export class UIBaseShareImage {
    async getImageFile() {
        var _this_imageLoadingCallback, _this, _this_imageLoadingCallback1, _this1;
        if (this.imageFile) {
            var _this_imageLoadingCallback2, _this2;
            (_this_imageLoadingCallback2 = (_this2 = this).imageLoadingCallback) === null || _this_imageLoadingCallback2 === void 0 ? void 0 : _this_imageLoadingCallback2.call(_this2, false);
            return this.imageFile;
        }
        (_this_imageLoadingCallback = (_this = this).imageLoadingCallback) === null || _this_imageLoadingCallback === void 0 ? void 0 : _this_imageLoadingCallback.call(_this, true);
        if (!this.imageGenerated) await this.generateImageOnce();
        if (!this.convertImagePromise) this.convertImagePromise = this.convertImage();
        await this.convertImagePromise;
        (_this_imageLoadingCallback1 = (_this1 = this).imageLoadingCallback) === null || _this_imageLoadingCallback1 === void 0 ? void 0 : _this_imageLoadingCallback1.call(_this1, false);
        return this.imageFile;
    }
    async generateImageOnce() {
        if (this.imageGenerated) return;
        if (this.generateImagePromise != undefined) return this.generateImagePromise;
        const generateImagePromise = createDeferredPromise();
        this.generateImagePromise = generateImagePromise;
        try {
            await this.generateImage();
            this.imageGenerated = true;
            generateImagePromise.resolve();
        } catch (error) {
            generateImagePromise.reject(error);
        } finally{
            if (this.generateImagePromise == generateImagePromise) this.generateImagePromise = undefined;
        }
        return generateImagePromise;
    }
    async convertImage() {
        const html2canvasModule = await import('html2canvas-pro');
        const html2canvas = html2canvasModule.default;
        const canvas = await html2canvas(this.container, {
            useCORS: true
        });
        return new Promise((resolve, reject)=>{
            canvas.toBlob((blob)=>{
                if (!blob) {
                    resolve(undefined);
                    return;
                }
                this.imageFile = new File([
                    blob
                ], 'colonist-game-results.png', {
                    type: blob.type
                });
                resolve(this.imageFile);
            }, 'image/png');
        });
    }
    createLogo() {
        createExternalImgIn(this.container, IconLogo, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'share-image-logo');
    }
    createColonistLink() {
        const linkContainer = createDivIn(this.container, 'share-image-url-container');
        createExternalImgIn(linkContainer, IconArrowWhite, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'share-image-url-arrow');
        createParagraphIn(linkContainer, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: 'colonist.io'
            }
        }, 'share-image-url');
    }
    constructor(uiGameManager, endGameState, imageLoadingCallback){
        this.imageGenerated = false;
        this.uiGameManager = uiGameManager;
        this.endGameState = endGameState;
        this.imageLoadingCallback = imageLoadingCallback;
        this.extract = this.uiGameManager.canvasController.app.renderer.extract;
        this.extract = this.uiGameManager.canvasController.app.renderer.extract;
        this.container = createDivIn(document.body, 'share-image-container');
        this.createLogo();
        this.createColonistLink();
    }
}
